import React, { useEffect, useState } from 'react'
import { Box,Card  ,CardContent ,Typography} from '@material-ui/core'
import Grafica from './GraficaParo2'
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },    
    title: {
      fontSize: 24,
    },
   
  }));
const FallaLadoDerecho = ({totales, }) => {
    
    const classes = useStyles();
    const [registro, setRegistro] = useState({paroTotalHora:"00:00:00", enservicio:100.00, paro:0.00, tParos:0});
    const {paroTotalHora, tParos, enservicio, paro} = registro
    useEffect(()=>{
       // console.log(totales);
        
        setRegistro({paroTotalHora: totales.paroTotalHora,  tParos:totales.paroRegistro,                        
            enservicio:recortaPorcentaje(totales.totalEficiente),  
            paro:recortaPorcentaje(totales.totalParo)})
    },[totales])

    function recortaPorcentaje(auxiliar) 
    {   
        let valor= 0;
        const valStr=`${auxiliar}`
        //console.log(auxiliar,valStr.length);
        if (auxiliar>10&&auxiliar<100) 
        {   if (valStr.length>3) 
            {
                valor= valStr.substring(0, 4)    
            }
            else
            {   valor= valStr.substring(0, 2)    
            }
        }
        else
        {   if (auxiliar===100) 
            {   valor= valStr.substring(0, 3)    
            }
            else
            {   if (valStr.length>3)
                {   valor= valStr.substring(0, 4)    
                }
                else
                {   valor= valStr.substring(0, 1)    
                }    
            }        
        }
        
        return valor
    }

    return (
    <React.Fragment>
        <Box width="25%"  ml={1} >                        
        <Box  justifyContent="center"  height="25%" >
            <Box mb={2} style={{ color: 'red'+100 }} >
                <Card   >
                    <CardContent >
                        <Box display="flex" flexDirection="row"  justifyContent="center" >
                        <Box mr={2} mt={1}>
                        <Typography className={classes.title}  variant="h4"
                             component="h1" align="center" //color={'secondary'} //textStyle="bold"   
                             style={{ fontSize:35,color: '#FF0D0D',fontWeight: '980'}} 
                        >
                          {paroTotalHora}
                        </Typography>                                    
                        <Typography color="textSecondary" align="center">
                            Tiempo de Paro
                        </Typography>
                        </Box> 
                        
                        <Box mr={2} mt={1}>
                            <Typography className={classes.title}  variant="h4"
                                component="h1" align="center" //color={'secondary'} //textStyle="bold"   
                                style={{ fontSize:35 ,color: '#FF0D0D',fontWeight: '980'}} 
                            >
                            {tParos}
                            </Typography>                                    
                            <Typography color="textSecondary" align="center">
                                Paros
                            </Typography>
                        </Box> 
                        </Box>
                    </CardContent>                                
                </Card>
            </Box>     
        </Box>
        <Box p={1} mt={1} height="75%">
            <Box display="flex" flexDirection="row" justifyContent="space-around">
                <Typography   variant="h5" component="h3"  //color={'secondary'} 
                      style={{ color: '#5DE163', fontSize:35 ,fontWeight:700}} //gutterBottom textStyle="bold" 
                >
                   {enservicio+"%"}
                </Typography>          
                <Typography variant="h5" component="h3"  //color={'secondary'}
                        style={{ color: '#FF0D0D',  fontSize:35,fontWeight:700 }} //gutterBottomalign="center" textStyle="bold"
                >
                    {paro+"%"}
                </Typography>
                                                              
            </Box>                         

        <Grafica    enservicio={enservicio} paro ={paro}/>
        </Box>
    </Box> 
</React.Fragment>
)
}

export default FallaLadoDerecho
